import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { IconName } from '@eluve/components';

import { CommandProviderState } from '../types';

type ActionEntry = {
  id: string;
  label: string;
  icon: IconName;
  /** Target path; if a future action isn't navigation, swap this for a handler. */
  to: string;
};

/**
 * Palette-only action surface — distinct from the admin tab registry so
 * sidebar/footer items live in one place and palette-specific entries
 * (exit, future shortcuts) live here.
 */
const ACTIONS: ActionEntry[] = [
  { id: 'return-to-app', label: 'Return to App', icon: 'LogOut', to: '/' },
];

export const useActionsResults = (query: string): CommandProviderState => {
  const navigate = useNavigate();
  const normalized = query.trim().toLowerCase();

  const results = useMemo(() => {
    const matching = normalized
      ? ACTIONS.filter((action) =>
          action.label.toLowerCase().includes(normalized),
        )
      : ACTIONS;

    return matching.map((action) => ({
      id: `action:${action.id}`,
      label: action.label,
      icon: action.icon,
      onSelect: () => navigate(action.to),
    }));
  }, [normalized, navigate]);

  return { results, loading: false };
};
